import React from 'react';
import { Box, CircularProgress } from '@mui/material';

interface LoadingSpinnerProps {
    loading: boolean;
    children?: React.ReactNode;
    centered?: boolean;
    className?: string;
    size?: number;
}

const LoadingSpinner = ({
    loading,
    children,
    centered = false,
    className,
    size = 50,
}: LoadingSpinnerProps): JSX.Element => {
    if (loading) {
        const spinner = (
            <CircularProgress
                className={className}
                size={size}
                sx={{ color: 'common.black' }}
            />
        );

        return centered ? (
            <Box
                sx={{
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'center',
                    width: '100%',
                }}>
                {spinner}
            </Box>
        ) : (
            spinner
        );
    }

    return <>{children}</>;
};

export { LoadingSpinner };
